<template>
<div class="chart" style="position: relative;">
  <div ref="chart"></div>
</div>
</template>

<script>
import Charts from 'apexcharts';

export default {
  name: 'chart',
  props: {
    iot: Object,
    update: String,
    defaultOptions: Object,
  },
  data() {
    return {
      chart: { },
      options: {
        yaxis: {
          min: 0,
          forceNiceScale: true,
        },
        chart: {
          height: '500',
          type: 'line',
          stacked: false,
        },
        colors: [
          '#008FFB',
          '#00E396',
          '#FEB019',
          '#FF4560',
          '#775DD0',
          '#8D5B4C',
        ],
        legend: {
          showForNullSeries: false,
          formatter(seriesName) {
            switch (seriesName) {
              case 'temperature':
                return `${seriesName} [&#176C]`;
              case 'light':
                return `${seriesName} [lux]`;
              case 'pressure':
                return `${seriesName} [kPa]`;
              case 'humidity':
                return `${seriesName} [%]`;
              case 'shockMagnitude':
                return 'shock [g]';
              case 'battery':
                return `${seriesName} [%]`;
              default:
                return seriesName;
            }
          },
        },
        markers: { size: 4 },
        tooltip: {
          intersect: true,
          shared: false,
          x: { format: 'dd MMM HH:mm:ss' },
        },
        dataLabels: { enabled: false },
        xaxis: { type: 'datetime', categories: [] },
        series: [
          {
            name: 'temperature',
            data: [],
          },
          {
            name: 'battery',
            data: [],
          },
          {
            name: 'light',
            data: [],
          },
          {
            name: 'shockMagnitude',
            data: [],
          },
          {
            name: 'pressure',
            data: [],
          },
          {
            name: 'humidity',
            data: [],
          },
        ],
        ...this.defaultOptions,
      },
    };
  },
  watch: {
    update() {
      this.render();
    },
  },
  computed: {
    trackers() {
      // eslint-disable-next-line
      return this.iot.hits.filter(h => h._source.tracker);
    },
  },
  methods: {
    render() {
      this.clear();
      this.setXAxis();
      this.setSeries();
    },
    setXAxis() {
      this.chart.updateOptions({
        xaxis: {
          type: 'datetime',
          // eslint-disable-next-line
          categories: this.trackers.map(h => h._source.timeOfReport),
        },
      });
    },
    setSeries() {
      const trackers = {
        temperature: [],
        battery: [],
        light: [],
        shockMagnitude: [],
        pressure: [],
        humidity: [],
      };

      /* eslint-disable */
      this.trackers.map((h) => {
        trackers.temperature.push(h._source.tracker.temperature != undefined
          ? h._source.tracker.temperature
          : null
        );
        trackers.battery.push(h._source.tracker.batteryPercent != undefined
          ? h._source.tracker.batteryPercent
          : null
        );
        trackers.light.push(h._source.tracker.light != undefined
          ? h._source.tracker.light
          : null
        );
        trackers.shockMagnitude.push(h._source.tracker.shockMagnitude != undefined
          ? h._source.tracker.shockMagnitude
          : null
        );
        trackers.pressure.push(h._source.tracker.pressure != undefined
          ? h._source.tracker.pressure
          : null
        );
        trackers.humidity.push(h._source.tracker.humidity != undefined
          ? h._source.tracker.humidity
          : null
        );
        return true;
      });
      /* eslint-enable */
      this.chart.updateSeries([
        {
          name: 'temperature',
          data: trackers.temperature,
        },
        {
          name: 'battery',
          data: trackers.battery,
        },
        {
          name: 'light',
          data: trackers.light,
        },
        {
          name: 'shockMagnitude',
          data: trackers.shockMagnitude,
        },
        {
          name: 'pressure',
          data: trackers.pressure,
        },
        {
          name: 'humidity',
          data: trackers.humidity,
        },
      ]);
    },
    clear() {
      this.chart.updateOptions({ });
      this.chart.updateSeries([]);
    },
  },
  mounted() {
    this.chart = new Charts(this.$refs.chart, this.options);
    this.chart.render();
    this.render();
  },
};
</script>
